export default __webpack_public_path__ + "static/media/Pilgrim's Hood of the Aureate.c77b088a.jpg";